import axios from "axios";

import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

const unauthorizedCode = [401, 403]

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000
})


service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers = {
			...((config.headers) ?? {}),
			Authorization: `Bearer ${jwtToken}`,
		}}

	return config
}, error => {
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

service.interceptors.request.use(config => {
	if (config.params) {
		Object.keys(config.params).forEach(k => {
			const v = config.params[k];
			if (v?.$isDayjsObject) {
				config.params[k] = v.format("YYYY-MM-DD HH:mm");
			}
		});
	}
	return config;
});


service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: 'Error',
		description: error?.response?.data?.message
	}

	// Remove token and redirect 
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = 'Authentication Fail'
		notificationParam.description = 'Please login again'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service